module.exports = __webpack_public_path__ + "img/icon-install.5e3c49ce.svg";